// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__dBAGP","formFields":"LoginForm_formFields__aodBg","forgotPasswordLink":"LoginForm_forgotPasswordLink__nx3Ii","submitButton":"LoginForm_submitButton__OEkkK"};